import React from 'react';

const CaseStudyGridItemSkeleton = () => {
  return (
    <div className="CaseStudyGridItemSkeleton flex flex-col gap-6">
      <div className="CaseStudyGridItemSkeleton__image w-full bg-white-skeleton">
        <div className="CaseStudyGridItemSkeleton__image-inner"></div>
      </div>
      <div className="flex flex-col space-y-1 w-11/12 desktop:w-3/5">
        <div className="bg-white-skeleton h-6 w-2/3 desktop:w-1/3"></div>
        <div className="bg-white-skeleton h-6 w-full"></div>
        <div className="bg-white-skeleton h-6 w-2/3"></div>
        <div className="bg-white-skeleton h-6 w-1/3 desktop:w-2/3"></div>
      </div>
    </div>
  );
};

export default CaseStudyGridItemSkeleton;
